import {useTranslation} from '@/translations/i18n'
import {Button} from '@/components/ui/button/Button'
import {Download01Icon, LayersThree01Icon} from '@/components/ui/icon/Icon'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {ExportCardShell} from './ExportCardShell'
import {StyledCardFooter, StyledDisabledActionWrapper, StyledIconChip, StyledSelectWrapper} from './style'

// UI-only placeholder: the "merge reports" capability has no backend yet, so the whole card is
// disabled and a tooltip explains it is not available (FR-015). Mirrors the DSP Flux card anatomy.
export const MergeReportsCard = () => {
    const {t} = useTranslation()

    return (
        <ExportCardShell
            disabled
            icon={
                <StyledIconChip $tone="neutral">
                    <LayersThree01Icon size={20} />
                </StyledIconChip>
            }
            title={t('dsp_flux_export:merge_card_title')}
        >
            <StyledCardFooter>
                <StyledSelectWrapper>
                    <InputSelect
                        disabled
                        optionsEntries={[]}
                        onChange={() => undefined}
                        placeholder={t('dsp_flux_export:month_select_placeholder')}
                    />
                </StyledSelectWrapper>
                <Tooltip
                    variant="light"
                    content={t('dsp_flux_export:merge_not_available')}
                    triggerProps={{asChild: true}}
                >
                    <StyledDisabledActionWrapper>
                        <Button variant="secondary" disabled>
                            <Download01Icon size={16} />
                            {t('dsp_flux_export:download_cta')}
                        </Button>
                    </StyledDisabledActionWrapper>
                </Tooltip>
            </StyledCardFooter>
        </ExportCardShell>
    )
}
